import { render, staticRenderFns } from "./BetslipTicketTypes.vue?vue&type=template&id=172b633f&scoped=true"
import script from "./BetslipTicketTypes.vue?vue&type=script&lang=js"
export * from "./BetslipTicketTypes.vue?vue&type=script&lang=js"
import style0 from "./BetslipTicketTypes.vue?vue&type=style&index=0&id=172b633f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b633f",
  null
  
)

export default component.exports